module.exports = __webpack_public_path__ + "static/icon-group-b110a9c715de5a769510fc4691e4a624.svg";